// Import builderFetch
import { builderFetch } from '../../utils';

// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { __ } from '@wordpress/i18n';

/**
 * Sets new recipe notes meta "uap_recipe_notes"
 *
 * @param {String} newNotes The recipe notes
 * @return {Promise} The apiFetch promise
 */
const setRecipeNotes = ( newNotes ) => {
	// Event name
	const eventName = 'uap/builder/core/set-recipe-notes';

	// Save the recipe title
	return builderFetch( {
		eventName: eventName,
		endpoint: 'change_recipe_notes',
		method: 'POST',
		data: {
			// eslint-disable-next-line camelcase
			post_ID: UncannyAutomator._recipe.recipe_id,
			// eslint-disable-next-line camelcase
			notes: newNotes
		},
		snackbar: {
			loading: escapeHTML( __( 'Updating recipe notes', 'uncanny-automator' ) ),
			success: escapeHTML( __( 'Recipe notes updated successfully', 'uncanny-automator' ) ),
		}
	} ).then( response => {
		// Check if the call was successful
		if ( response.success ) {
			// Send custom event to the document
			document.dispatchEvent( new CustomEvent( eventName, {
				detail: {
					recipeNotes: newNotes
				}
			} ) );
		}

		return response;
	} );
}

export default setRecipeNotes;
